import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.string.trim.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { getCurrentInstance } from 'vue';
import IxFormInputDatePicker from '~/components/ix/form-input/DatePicker.vue';
import { useUpsertReportingRequestMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'EditRequestDialog',
  props: {
    reportingRequestId: null,
    initialTitle: null,
    initialDescription: null,
    initialDueDate: null
  },
  emits: ['success'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _ref2 = getCurrentInstance(),
      proxy = _ref2.proxy;
    var dialogOpen = ref(false);
    var requestTitle = ref('');
    var description = ref('');
    var dueDate = ref(null);
    var titleError = ref(false);
    var submitting = ref(false);
    var _useUpsertReportingRe = useUpsertReportingRequestMutation({}),
      upsertReportingRequest = _useUpsertReportingRe.mutate;
    var resetForm = function resetForm() {
      requestTitle.value = props.initialTitle || '';
      description.value = props.initialDescription || '';
      dueDate.value = props.initialDueDate || null;
      titleError.value = false;
    };
    watch(dialogOpen, function (isOpen) {
      if (isOpen) {
        resetForm();
      }
    });
    var close = function close() {
      dialogOpen.value = false;
    };
    var clearDescription = function clearDescription() {
      description.value = '';
    };
    var copyDescription = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (description.value) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.next = 4;
              return navigator.clipboard.writeText(description.value);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function copyDescription() {
        return _ref3.apply(this, arguments);
      };
    }();
    var submit = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (requestTitle.value.trim()) {
                _context2.next = 3;
                break;
              }
              titleError.value = true;
              return _context2.abrupt("return");
            case 3:
              submitting.value = true;
              _context2.prev = 4;
              _context2.next = 7;
              return upsertReportingRequest({
                input: {
                  id: props.reportingRequestId,
                  title: requestTitle.value.trim(),
                  description: description.value,
                  dueDate: dueDate.value || null
                }
              });
            case 7:
              window.$nuxt.$emit('userMsg', {
                color: 'green',
                message: proxy.$t('successUpdate')
              });
              emit('success');
              close();
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](4);
              window.$nuxt.$emit('userError', {
                message: (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || String(_context2.t0)
              });
            case 15:
              _context2.prev = 15;
              submitting.value = false;
              return _context2.finish(15);
            case 18:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[4, 12, 15, 18]]);
      }));
      return function submit() {
        return _ref4.apply(this, arguments);
      };
    }();
    return {
      __sfc: true,
      props: props,
      emit: emit,
      proxy: proxy,
      dialogOpen: dialogOpen,
      requestTitle: requestTitle,
      description: description,
      dueDate: dueDate,
      titleError: titleError,
      submitting: submitting,
      upsertReportingRequest: upsertReportingRequest,
      resetForm: resetForm,
      close: close,
      clearDescription: clearDescription,
      copyDescription: copyDescription,
      submit: submit,
      IxFormInputDatePicker: IxFormInputDatePicker
    };
  }
});